export var getRandomId = function getRandomId(len) {
  var str = '1234567890-qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM';
  var strLen = str.length;
  var res = '';
  for (var i = 0; i < len; i++) {
    var randomIndex = Math.floor(Math.random() * strLen);
    res += str[randomIndex];
  }
  return res;
};